.icon {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify($themes) {
    background: themed("main-primary");
  }
  border-radius: 50%;
  
  svg {
    @include themify($themes) {
      color: themed("main-secondary");
    }
  }
}
